import {
  DOKUMENT_STATUS_LABELS,
  listDokumente,
  type DokumentStatus,
} from "@/lib/dokumente";

/** Hinweis vor einem weiteren Lieferschein zum selben Projekt. */
export const EXISTING_LIEFERSCHEIN_WARNING =
  "Achtung! Lieferschein zum Projekt bereits vorhanden. Bitte prüfen, ob die Artikel bereits erfasst wurden, bevor ein neuer Lieferschein erstellt wird.";

export type ExistingLieferscheinHint = {
  id: number;
  label: string;
  statusLabel: string;
};

export type ExistingLieferscheinSource = {
  id: number;
  dokument_typ?: string | null;
  status?: string | null;
  display_number?: string | null;
  dokument_nummer?: string | null;
  has_newer_revision?: boolean | null;
  quelle?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
};

function recency(row: ExistingLieferscheinSource): number {
  const raw = row.updated_at || row.created_at;
  const parsed = raw ? Date.parse(raw) : Number.NaN;
  if (Number.isFinite(parsed)) return parsed;
  return Number.isFinite(row.id) ? row.id : 0;
}

/** Aktive App-Lieferscheine, neueste zuerst. Stornos und alte Versionen zählen nicht. */
export function toExistingLieferscheinHints(
  rows: ExistingLieferscheinSource[],
): ExistingLieferscheinHint[] {
  return rows
    .filter((row) => {
      if (row.dokument_typ && row.dokument_typ !== "lieferschein") return false;
      if (row.quelle === "hero_customer_document") return false;
      if (!Number.isFinite(row.id) || row.id <= 0) return false;
      if (row.has_newer_revision) return false;
      if (String(row.status || "").toLowerCase() === "storniert") return false;
      return true;
    })
    .sort((a, b) => recency(b) - recency(a) || b.id - a.id)
    .map((row) => {
      const status = String(row.status || "") as DokumentStatus;
      return {
        id: row.id,
        label: String(row.display_number || row.dokument_nummer || `#${row.id}`).trim(),
        statusLabel: DOKUMENT_STATUS_LABELS[status] || String(row.status || ""),
      };
    });
}

export async function loadExistingLieferscheine(
  auftragId: number,
): Promise<ExistingLieferscheinHint[]> {
  const rows = await listDokumente({
    auftrag_id: auftragId,
    typ: "lieferschein",
    limit: 50,
  });
  return toExistingLieferscheinHints(rows);
}
